var _path, _mask, _g, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExceeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 133,
    viewBox: "0 0 135 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 133C100.122 133 129 104.122 129 68.5C129 32.8776 100.122 4 64.5 4C28.8776 4 0 32.8776 0 68.5C0 104.122 28.8776 133 64.5 133Z",
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 129,
    height: 129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5 133C100.122 133 129 104.122 129 68.5C129 32.8776 100.122 4 64.5 4C28.8776 4 0 32.8776 0 68.5C0 104.122 28.8776 133 64.5 133Z",
    fill: "url(#paint1_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-84.29 90.0245C-77.7183 90.0245 -72.2796 93.143 -70.92 97.2539C-67.7474 92.2925 -60.4958 88.8905 -52.1112 88.8905C-45.5395 88.8905 -39.7609 91.0168 -36.0218 94.2771C-32.6227 89.8119 -25.711 86.8351 -17.8929 86.8351C-10.6414 86.8351 -4.18295 89.4575 -0.557167 93.3557C1.82225 91.3711 5.56133 90.0954 9.64034 90.0954C14.7391 90.0954 19.158 92.0799 21.4241 94.9858C27.316 89.4575 36.8337 85.8428 47.5977 85.8428C57.7952 85.8428 66.973 89.1031 72.8649 94.1353C75.6975 90.308 81.4761 87.6856 88.2744 87.6856C95.1861 87.6856 101.078 90.4497 103.911 94.4188C106.403 92.3634 110.142 91.0876 114.448 91.0876C120 91.0876 124.872 93.3557 127.025 96.6869C129.631 90.9459 137.449 86.8351 146.627 86.8351C154.672 86.8351 161.696 90.0245 164.982 94.6314C166.569 92.9304 169.515 91.7255 172.687 91.7255C175.406 91.7255 177.899 92.576 179.599 93.8518C183.904 88.0399 192.742 84 202.94 84C217.33 84 229 92.009 229 101.79V139H-98V99.3802C-98 94.2771 -91.8815 90.0245 -84.29 90.0245Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0263 42.3534L69.0925 24.914L133.168 14.4844L133.272 14.8072L50.0263 42.3534Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.272 14.8074L134.495 16.833L59.8719 65.3275L50.0262 42.3536L133.272 14.8074Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.989 15.6875L134.495 16.8336L65.9362 73.7588L43.902 54.8077L132.989 15.6875Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.989 15.6875L54.315 63.7324L43.902 54.8077L132.989 15.6875Z",
    fill: "#D3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.989 15.6869L132.795 15.9652L25 73.1927L42.7609 50.182L132.989 15.6869Z",
    fill: "url(#paint5_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8101 45.0536C92.4655 48.1314 90.7342 49.8433 87.6202 50.186C90.7342 50.5268 92.4655 52.2386 92.8101 55.3165C93.1568 52.2386 94.8861 50.5268 98 50.186C94.8861 49.8433 93.1568 48.1314 92.8101 45.0536ZM20.1519 43C19.8748 45.4621 18.4911 46.8321 16 47.1052C18.4911 47.3792 19.8748 48.7482 20.1519 51.2103C20.429 48.7492 21.8127 47.3802 24.3038 47.1052C21.8137 46.8321 20.429 45.4621 20.1519 43ZM49.2152 71.7361C48.8695 74.815 47.1392 76.5268 44.0253 76.8685C47.1392 77.2103 48.8695 78.9221 49.2152 82C49.5608 78.9221 51.2911 77.2103 54.4051 76.8685C51.2911 76.5268 49.5619 74.815 49.2152 71.7361Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0410455,
    y1: 68.4694,
    x2: 128.966,
    y2: 68.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4104,
    stopColor: "#1D4DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.0410455,
    y1: 68.4694,
    x2: 128.966,
    y2: 68.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4104,
    stopColor: "#1D4DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 90.9142,
    y1: 27.7677,
    x2: 66.0696,
    y2: 4.42729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E0FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 108.221,
    y1: 73.254,
    x2: 92.9074,
    y2: 32.1285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 102.468,
    y1: 59.3747,
    x2: 90.1436,
    y2: 37.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 79.5225,
    y1: 39.0397,
    x2: 76.4391,
    y2: 74.0466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E0FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 74,
    fill: "white",
    transform: "translate(35.8994) rotate(8.46996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExceeded);
export default __webpack_public_path__ + "static/media/icon_exceeded.37f4a5189421c70eebb3c4e154c02f87.svg";
export { ForwardRef as ReactComponent };